var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"pb-4 dark",class:{'full-width__content': _vm.sidebarToggled},attrs:{"role":"main"}},[_c('TopBannerNotice'),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }